import { render, staticRenderFns } from "./veStuHealthReportShow.vue?vue&type=template&id=5bc0da76&scoped=true"
import script from "./veStuHealthReportShow.vue?vue&type=script&lang=js"
export * from "./veStuHealthReportShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc0da76",
  null
  
)

export default component.exports